//E:\SAUDIDUNES11\frontend\src\pages\CarListPage.js
import styled from "styled-components";

import Announcement from "../components/Announcement";
import Products from "../components/Products";
import Newsletter from "../components/Newsletter";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import { useLocation } from "react-router";
import { useState } from "react";

const Container = styled.div``;

const Title = styled.h1`
  margin: 20px;
`;

const FilterContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Filter = styled.div`
  margin: 20px;
`;

const FilterText = styled.span`
  font-size: 20px;
  font-weight: 600;
  margin-right: 20px;
`;

const Select = styled.select`
  padding: 10px;
  margin-right: 20px;
`;

const Option = styled.option``;

/* Human-readable country labels for the SEO title and page heading.
   Each key matches the carproducer value from data.js / carOptions key
   from NewCar.js. Falls back to the raw URL segment for anything unknown. */
const COUNTRY_LABELS = {
  USA: "American",
  Japan: "Japanese",
  Germany: "German",
  China: "Chinese",
  Korea: "Korean",
  UK: "British",
};

const CarListPage = () => {
  const location = useLocation();
  const country = decodeURIComponent(location.pathname.split("/")[2] || "");
  const [filters, setFilters] = useState({});
  const [sort, setSort] = useState("newest");

  const label = COUNTRY_LABELS[country] || country;

  const handleFilters = (e) => {
    const value = e.target.value;
    setFilters({
      ...filters,
      [e.target.name]: value,
    });
  };

  return (
    <Container>
      <SEO
        title={`${label} Cars for Sale in Saudi Arabia — SaudiDune`}
        description={`Browse ${label} cars for sale across Saudi Arabia on SaudiDune — filter by year and odometer, sort by price and newest listings.`}
      />

      <Title>{label} Cars</Title>

      <FilterContainer>
        <Filter>
          <FilterText>Filter Cars:</FilterText>

          <Select name="year" onChange={handleFilters}>
            <Option disabled>Select Year Range</Option>
            <Option value="2000">Year ≥ 2000</Option>
            <Option value="2005">Year ≥ 2005</Option>
            <Option value="2010">Year ≥ 2010</Option>
            <Option value="2015">Year ≥ 2015</Option>
            <Option value="2020">Year ≥ 2020</Option>
            <Option value="2025">Year ≥ 2025</Option>
          </Select>

          <Select name="odometer" onChange={handleFilters}>
            <Option disabled>Select Max Odometer</Option>
            <Option value="10000">≤ 10,000 km</Option>
            <Option value="15000">≤ 15,000 km</Option>
            <Option value="20000">≤ 20,000 km</Option>
            <Option value="25000">≤ 25,000 km</Option>
            <Option value="30000">≤ 30,000 km</Option>
            <Option value="35000">≤ 35,000 km</Option>
            <Option value="40000">≤ 40,000 km</Option>
            <Option value="45000">≤ 45,000 km</Option>
            <Option value="50000">≤ 50,000 km</Option>
          </Select>
        </Filter>

        <Filter>
          <FilterText>Sort Cars:</FilterText>

          <Select onChange={(e) => setSort(e.target.value)}>
            <Option value="newest">Newest</Option>
            <Option value="asc">Price (asc)</Option>
            <Option value="desc">Price (desc)</Option>
          </Select>
        </Filter>
      </FilterContainer>

      <Products mode="cars" country={country} filters={filters} sort={sort} />
      <Newsletter />
      <Footer />
    </Container>
  );
};

export default CarListPage;
